import { unwrap } from '@/lib/apiEnvelope'
import { httpClient } from '@/lib/httpClient'
import type { ApiResponse, Paginated } from '@/types/api'

import type {
  ComunicadoImagem,
  MeuComunicado,
  MeuComunicadoListFilters,
} from '../types/meuComunicado'

export const meusComunicadosApi = {
  list: async (filters: MeuComunicadoListFilters): Promise<Paginated<MeuComunicado>> => {
    const params: Record<string, string | number | boolean> = {
      page: filters.page,
      pageSize: filters.pageSize,
    }
    if (filters.apenasNaoVisualizados) params.apenasNaoVisualizados = true
    const response = await httpClient.get<ApiResponse<Paginated<MeuComunicado>>>(
      '/meus-comunicados',
      { params },
    )
    return unwrap(response)
  },

  marcarVisualizado: async (id: string): Promise<void> => {
    await httpClient.patch(`/meus-comunicados/${id}/visualizar`)
  },

  /** A listagem paginada não traz as imagens: buscar ao abrir o comunicado. */
  imagens: async (id: string): Promise<ComunicadoImagem[]> => {
    const response = await httpClient.get<ApiResponse<ComunicadoImagem[]>>(
      `/meus-comunicados/${id}/imagens`,
    )
    return unwrap(response)
  },
}
